/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import '../styles/marcaciones.css';

// Components
// Material Mui
import { Grid, 
  TextField, 
  Tooltip,
  Button, 
  Autocomplete, 
  useMediaQuery,
  Card,
  CardContent,  
  Typography,
  CircularProgress,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  DialogContentText,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  Box
} from "@mui/material";
import { DataGrid } from '@mui/x-data-grid';
import { makeStyles } from '@mui/styles';

// Customs
import Item from '../components/custom/Item';
import Heading from '../components/heading/Heading';
import Formatter from '../scripts/formatters';
import CustomNoRowsOlverlay from '../components/custom/CustomNoRowsOlverlay';
import msgNotificacion from '../scripts/notification';
import CustomToolBar from '../components/custom/CustomToolbar';

// Iconos
import RestartAltIcon from '@mui/icons-material/RestartAlt';
import PictureAsPdfOutlinedIcon from '@mui/icons-material/PictureAsPdfOutlined';
import AddIcon from '@mui/icons-material/Add';

// PDF
import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';
import LogoFS from '../assets/images/logoFS.png';

// Redux
import { useDispatch } from 'react-redux';
import { showProgress } from '../redux/reducers/progress.Slice';
import { PAGE_SIZE, NAME_PROJECT } from '../redux/constants/index';

// Services
import EmpleadoService from '../services/empleadoService';

// Estilos personalizados DataGrid
const useStyles = makeStyles({
  customValue: {
    color: 'red',
    backgroundColor: 'lavenderblush', // Para celdas
  },
  customCell: {
    color: 'red',
    backgroundColor: 'lightblue', // Estilos personalizados para las celdas
  },
  customCellIn: {
    color: '#212529',
    backgroundColor: 'limegreen' // Para celdas con status Entrada
  },
  customCellOut: {
    color: '#fff',
    backgroundColor: '#f27474', // Para celdas con status Salida
  },
  customCellBreak: {
    color: 'red',
    backgroundColor: 'lightyellow', // Para celdas con status ALMUERZO
  },
});

export default function Marcaciones() {
  const userLogin = JSON.parse(localStorage.getItem('user'))
  const dispatch = useDispatch()
  const isMobile = useMediaQuery('(max-width: 740px)')

  // States
  const [loading, setLoading] = useState(false)
  const [dataMarcaciones, setDataMarcaciones] = useState([])
  const [dataEmpleadosCbo, setDataEmpleadosCbo] = useState([])
  const [empleadoSelected, setEmpleadoSelected] = useState(null)
  const [filteredData, setFilteredData] = useState([])  
  const [valueFechas, setValueFechas] = useState({
    fechaIni: '',
    fechaFin: '',
  })
  
  // Modal de registro manual
  const [modalRegistroManual, setModalRegistroManual] = useState({
    open: false,
    empleado: null,
    fecha: '',
    hora: '',
    tipoMarcacion: ''
  })

  const columns = [
    { 
      field: 'Consecutivo',
      headerName: 'Consecutivo',
      width: 100,
      align: 'center',
      headerAlign: 'center',
      resizable: false
    },
    { 
      field: 'CodigoEmpleado',
      headerName: 'No. Empleado',
      width: 120,
      align: 'center',
      headerAlign: 'center',
      resizable: false
    },
    { 
      field: 'Nombre',
      headerName: 'Nombre del Empleado',
      minWidth: 200,
      align: 'left',
      headerAlign: 'left',
      flex: 1,
    },
    { 
      field: 'Cargo',
      headerName: 'Cargo',
      minWidth: 200,
      align: 'left',
      headerAlign: 'left',
      flex: 1,
    },  
    { 
      field: 'FechaHora',
      headerName: 'Fecha marcación',
      width: 150,
      align: 'center',
      headerAlign: 'center',
      valueFormatter: ( value ) => Formatter.dateTimeFormatter(value),
    },
    { 
      field: 'StatusText',
      headerName: 'Estatus',
      width: 180,
      align: 'center',
      headerAlign: 'center',      
    },
    { 
      field: 'UsuarioCreacion',
      headerName: 'Usuario Creación',
      width: 150,
      align: 'center',
      headerAlign: 'center',
      renderCell: (params) => {
        const value = params.value || params.row?.UsuarioCreacion;
        // Si el valor es null, undefined, vacío o 'SISTEMA', mostrar 'SISTEMA'
        const displayValue = (!value || value === 'SISTEMA' || value === null || value === undefined || value === '') 
          ? 'SISTEMA' 
          : value.toUpperCase();
        return <span>{displayValue}</span>;
      }
    },
    { 
      field: 'FechaCreacion',
      headerName: 'Fecha Creación',
      width: 180,
      align: 'center',
      headerAlign: 'center',
      valueFormatter: ( value ) => Formatter.dateTimeFormatter(value),
    }, 
  ]

  const classes = useStyles();

  const getCellClassName = (params) => {
    // Condición para aplicar la clase CSS al valor específico de la celda
    if (params.field === 'StatusText' && params?.value === 'ENTRADA') {
      return classes.customCellIn;
    } 

    if (params.field === 'StatusText' && params?.value === 'SALIDA') {
      return classes.customCellOut;
    }

    if (params.field === 'StatusText' && params?.value && params.value.slice(0,8) === 'ALMUERZO') {
      return classes.customCellBreak;
    }

    return '';
  };

  // Arrow functions.
  const handleChangeFechas = (event) => {
    try {
      setValueFechas({
        ...valueFechas,
        [event.target.name]: event.target.value
      })
    } catch (error) {
      console.error(error)
    }
  }

  // Get Vacaciones.
  const getMarcaciones = async (data) => {
    try {      
      setLoading(true)

      EmpleadoService.getMarcaciones(data)
      .then((response) => {
          if (!response) {
            msgNotificacion('Error de conexión con la API, consulte al administrador del sitio.', 'error')
            setLoading(false)
            return
          }          
  
          setTimeout(() => {
            if (response.Codigo === 1) {
              const dataResponse = response?.Data
              
              // Debug: Ver qué datos están llegando
              if (dataResponse && dataResponse.length > 0) {
                console.log('Primera marcación recibida:', dataResponse[0]);
                console.log('Campos disponibles:', Object.keys(dataResponse[0]));
              }
              
              setDataMarcaciones(dataResponse)
              
              if (!valueFechas.fechaIni || !valueFechas.fechaFin) {
                setFilteredData(dataResponse)
              } else {
                filtrarMarcaciones(valueFechas.fechaIni, valueFechas.fechaFin)
              }
            } else {
              setDataMarcaciones([])
              setFilteredData([])
              msgNotificacion(response.Mensaje, 'info')
            }
            setLoading(false)
          }, 500);
      })
      .catch((error) => {
        dispatch(showProgress(false));
        msgNotificacion(error, 'error')
      })
    } catch (error) {
      console.error(error)
    }
  }

  const filtrarMarcaciones = (fecha1, fecha2) => {
    try {      
      const fechaIni = new Date(fecha1)
      const fechaFin = new Date(fecha2)
      
      const filteredData = dataMarcaciones.filter((item) => {
        const itemDate = formatearFecha(item.FechaHora)
        const fecha = new Date(itemDate)
        
        return fecha >= fechaIni && fecha <= fechaFin
      })
        
      setFilteredData(filteredData)    
    } catch (error) {
      console.error(error)
    }
  }

  const formatearFecha = (date) => {
    if (!date) {
      return
    }
  
    let dateAsString = date.toString().substring(0, 10)
    let dateParts = dateAsString.split("-")
    let day = dateParts[2]
    let month = dateParts[1]
    let year = dateParts[0]
  
    return `${year}-${month}-${day}`;
  }

  const refreshMarcaciones = () => {
    try {
      const dataRequest = {
        codEmpleado: !empleadoSelected ? userLogin.CodigoEmpleado : empleadoSelected.id
      }

      //console.log(dataRequest)
      getMarcaciones(dataRequest)
    } catch (error) {
      console.error(error)
    }
  }

  const getDatosEmpleadosCbo = async () => {
    try {
      const data = {
        codEmpleado: userLogin.CodigoEmpleado
      }
      
      EmpleadoService.getEmpleadosMarcaciones(data)
        .then((response) => {
          if (!response) {
            msgNotificacion('Error de conexión con la API, consulte al administrador del sitio.', 'error')
            return
          }
  
          if (response.Codigo === 1) {
            const dataEmpleados = response?.Data || []

            setDataEmpleadosCbo(dataEmpleados)
          } else {
            setDataEmpleadosCbo([])
            msgNotificacion(response.Mensaje, 'warning')
          }
        })
        .catch((error) => {
          msgNotificacion(error, 'error')
          dispatch(showProgress(false))
        })
    } catch (error) {
      console.error(error)
    }
  }

  const handleChangeEmpleado = (event, values) => {
    try {
      setEmpleadoSelected(values)
      
      //console.log(values)
      if (!values) {
        setLoading(true)
        
        setTimeout(() => {
          setFilteredData([])
          setLoading(false)
        }, 500);

        return
      }

      setLoading(true)
      
      const codEmpleado = values.id
      const data = {
        codEmpleado: codEmpleado
      }

      setTimeout(() => {
        getMarcaciones(data)
        setLoading(false)
      }, 500);

    } catch (error) {
      console.error(error)
    }    
  }

  // Funciones para el modal de registro manual
  const handleOpenModalRegistro = () => {
    try {
      // Si hay un empleado seleccionado, usarlo; si no, usar el empleado del usuario logueado
      const empleadoModal = empleadoSelected || (dataEmpleadosCbo.find(emp => emp.id === userLogin.CodigoEmpleado) || null)
      
      setModalRegistroManual({
        open: true,
        empleado: empleadoModal,
        fecha: new Date().toISOString().split('T')[0], // Fecha actual
        hora: new Date().toTimeString().slice(0, 5), // Hora actual (HH:MM)
        tipoMarcacion: ''
      })
    } catch (error) {
      console.error(error)
    }
  }

  const handleCloseModalRegistro = () => {
    try {
      setModalRegistroManual({
        open: false,
        empleado: null,
        fecha: '',
        hora: '',
        tipoMarcacion: ''
      })
    } catch (error) {
      console.error(error)
    }
  }

  const handleChangeModalRegistro = (field, value) => {
    try {
      setModalRegistroManual(prev => ({
        ...prev,
        [field]: value
      }))
    } catch (error) {
      console.error(error)
    }
  }

  const handleRegistrarMarcacionManual = async () => {
    try {
      // Validar campos obligatorios
      if (!modalRegistroManual.empleado) {
        msgNotificacion('Debe seleccionar un empleado', 'warning')
        return
      }

      if (!modalRegistroManual.fecha) {
        msgNotificacion('Debe seleccionar una fecha', 'warning')
        return
      }

      if (!modalRegistroManual.hora) {
        msgNotificacion('Debe ingresar una hora', 'warning')
        return
      }

      if (!modalRegistroManual.tipoMarcacion) {
        msgNotificacion('Debe seleccionar un tipo de marcación', 'warning')
        return
      }

      dispatch(showProgress(true))

      const dataRequest = {
        codEmpleado: modalRegistroManual.empleado.id,
        codEmpresa: 'FSRA',
        fecha: modalRegistroManual.fecha,
        hora: modalRegistroManual.hora + ':00', // Agregar segundos
        tipoMarcacion: modalRegistroManual.tipoMarcacion,
        usuarioCreacion: userLogin.CodigoUsuario || userLogin.Usuario || userLogin.NombreUsuario
      }

      const response = await EmpleadoService.registrarMarcacionManual(dataRequest)

      if (!response) {
        msgNotificacion('Error de conexión con la API, consulte al administrador del sitio.', 'error')
        dispatch(showProgress(false))
        return
      }

      setTimeout(() => {
        if (response.Codigo === 1) {
          msgNotificacion(response.Mensaje || 'Marcación registrada correctamente', 'success')
          handleCloseModalRegistro()
          // Refrescar las marcaciones
          refreshMarcaciones()
        } else {
          msgNotificacion(response.Mensaje || 'Error al registrar la marcación', 'error')
        }
        dispatch(showProgress(false))
      }, 500)

    } catch (error) {
      console.error(error)
      dispatch(showProgress(false))
      msgNotificacion('Error al registrar la marcación', 'error')
    }
  }

  // Generar reporte PDF de actividad
  const generarReportePDF = async () => {
    try {
      // Validar fechas obligatorias
      if (!valueFechas.fechaIni || !valueFechas.fechaFin) {
        msgNotificacion('Las fechas de inicio y fin son obligatorias para generar el reporte.', 'warning')
        return
      }

      // Validar que fecha final sea mayor o igual a fecha inicial
      if (new Date(valueFechas.fechaFin) < new Date(valueFechas.fechaIni)) {
        msgNotificacion('La fecha final debe ser mayor o igual a la fecha inicial.', 'warning')
        return
      }

      dispatch(showProgress(true))
      setLoading(true)

      // Los inputs de tipo date devuelven formato YYYY-MM-DD directamente
      // Asegurarse de que las fechas estén en el formato correcto
      let fechaInicio = valueFechas.fechaIni;
      let fechaFinal = valueFechas.fechaFin;

      // Si vienen en formato DD/MM/YYYY, convertirlas a YYYY-MM-DD
      if (fechaInicio && fechaInicio.includes('/')) {
        const partes = fechaInicio.split('/');
        fechaInicio = `${partes[2]}-${partes[1]}-${partes[0]}`;
      }
      
      if (fechaFinal && fechaFinal.includes('/')) {
        const partes = fechaFinal.split('/');
        fechaFinal = `${partes[2]}-${partes[1]}-${partes[0]}`;
      }

      // Validar formato YYYY-MM-DD
      const fechaRegex = /^\d{4}-\d{2}-\d{2}$/;
      if (!fechaRegex.test(fechaInicio) || !fechaRegex.test(fechaFinal)) {
        msgNotificacion('Formato de fecha inválido. Use el formato YYYY-MM-DD.', 'error');
        setLoading(false);
        dispatch(showProgress(false));
        return;
      }

      const dataRequest = {
        codEmpleado: empleadoSelected ? empleadoSelected.id : null,
        fechaInicio: fechaInicio,
        fechaFinal: fechaFinal
      }

      console.log('Datos enviados al backend:', dataRequest); // Para debug

      EmpleadoService.getReporteActividadEmpleado(dataRequest)
        .then((response) => {
          if (!response) {
            msgNotificacion('Error de conexión con la API, consulte al administrador del sitio.', 'error')
            setLoading(false)
            dispatch(showProgress(false))
            return
          }

          if (response.Codigo === 1) {
            const dataReporte = response?.Data || []
            
            if (dataReporte.length === 0) {
              msgNotificacion('No se encontraron datos para el reporte en el rango de fechas seleccionado.', 'info')
              setLoading(false)
              dispatch(showProgress(false))
              return
            }

            // Generar PDF
            generarPDF(dataReporte, dataRequest)
            setLoading(false)
            dispatch(showProgress(false))
          } else {
            msgNotificacion(response.Mensaje || 'Error al obtener el reporte.', 'error')
            setLoading(false)
            dispatch(showProgress(false))
          }
        })
        .catch((error) => {
          console.error(error)
          msgNotificacion('Error al generar el reporte.', 'error')
          setLoading(false)
          dispatch(showProgress(false))
        })
    } catch (error) {
      console.error(error)
      msgNotificacion('Error al generar el reporte.', 'error')
      setLoading(false)
      dispatch(showProgress(false))
    }
  }

  // Función para generar el PDF
  const generarPDF = (data, filtros) => {
    try {
      const doc = new jsPDF('landscape'); // Modo horizontal para más espacio
      
      // Logo
      const imgWidth = 40;
      const imgHeight = 20;
      const x = doc.internal.pageSize.getWidth() - imgWidth - 10;
      const y = 4;
      doc.addImage(LogoFS, 'PNG', x, y, imgWidth, imgHeight);
      
      // Título
      doc.setFontSize(16);
      doc.setTextColor(200, 0, 0); // Rojo
      doc.text('REPORTE DE ACTIVIDAD DE EMPLEADOS', 14, 15);
      
      // Función para formatear horas (igual que en HorasExtras)
      const formatTime = (timeValue) => {
        if (!timeValue) return '-';
        
        try {
          // Si viene como string de hora (HH:MM:SS), convertirlo
          if (typeof timeValue === 'string' && timeValue.includes(':') && !timeValue.includes('T')) {
            const [hours, minutes] = timeValue.split(':');
            const hour = parseInt(hours, 10);
            const min = parseInt(minutes, 10);
            const ampm = hour >= 12 ? 'PM' : 'AM';
            const displayHour = hour % 12 || 12;
            return `${displayHour}:${min.toString().padStart(2, '0')} ${ampm}`;
          }
          
          // Si viene como string ISO (1970-01-01T17:00:00.000Z), extraer solo la hora
          if (typeof timeValue === 'string' && timeValue.includes('T')) {
            const timePart = timeValue.split('T')[1];
            if (timePart) {
              const timeWithoutMs = timePart.split('.')[0]; // Remover milisegundos
              const [hours, minutes] = timeWithoutMs.split(':');
              const hour = parseInt(hours, 10);
              const min = parseInt(minutes, 10);
              const ampm = hour >= 12 ? 'PM' : 'AM';
              const displayHour = hour % 12 || 12;
              return `${displayHour}:${min.toString().padStart(2, '0')} ${ampm}`;
            }
          }
          
          // Si viene como Date, extraer solo la hora
          const date = new Date(timeValue);
          if (!isNaN(date.getTime())) {
            const hours = date.getHours();
            const minutes = date.getMinutes();
            const ampm = hours >= 12 ? 'PM' : 'AM';
            const displayHour = hours % 12 || 12;
            return `${displayHour}:${minutes.toString().padStart(2, '0')} ${ampm}`;
          }
          
          return '-'; // Fallback
        } catch (error) {
          return '-'; // Fallback
        }
      };

      // Información del reporte
      doc.setFontSize(10);
      doc.setTextColor(0, 0, 0); // Negro
      const empleadoTexto = filtros.codEmpleado 
        ? `Empleado: ${filtros.codEmpleado}` 
        : 'Empleado: TODOS';
      doc.text(empleadoTexto, 14, 22);
      
      // Formatear fechas correctamente usando Formatter.dateFormatter
      // Asegurarse de que las fechas estén en formato string YYYY-MM-DD
      const fechaInicioFormateada = Formatter.dateFormatter(filtros.fechaInicio);
      const fechaFinalFormateada = Formatter.dateFormatter(filtros.fechaFinal);
      
      // Formatear fecha de generación correctamente
      const fechaActual = new Date();
      const fechaGenString = fechaActual.toISOString().split('T')[0]; // YYYY-MM-DD
      const fechaGeneracion = Formatter.dateFormatter(fechaGenString);
      
      doc.text(`Fecha Inicio: ${fechaInicioFormateada}`, 14, 27);
      doc.text(`Fecha Final: ${fechaFinalFormateada}`, 14, 32);
      doc.text(`Fecha de Generación: ${fechaGeneracion}`, 14, 37);

      // Agrupar datos por empleado
      const datosAgrupados = {};
      data.forEach(row => {
        const key = `${row.CodEmpleado}_${row.Nombre}_${row.Departamento}`;
        if (!datosAgrupados[key]) {
          datosAgrupados[key] = {
            CodEmpleado: row.CodEmpleado,
            Nombre: row.Nombre,
            Departamento: row.Departamento,
            registros: []
          };
        }
        datosAgrupados[key].registros.push(row);
      });

      // Columnas de la tabla (sin código, nombre y departamento)
      const columns = [
        'Fecha',
        'H. Entrada',
        'H. Salida',
        'H. Extras',
        'H. Trabajadas',
        'Citas Méd.',
        'Vacaciones',
        'Permisos',
        'Incapacidad',
        'Total H. Laboradas'
      ];

      // Ordenar grupos por departamento y luego por código de empleado
      const grupos = Object.values(datosAgrupados).sort((a, b) => {
        // Primero ordenar por departamento
        if (a.Departamento < b.Departamento) return -1;
        if (a.Departamento > b.Departamento) return 1;
        // Si el departamento es igual, ordenar por código de empleado
        if (a.CodEmpleado < b.CodEmpleado) return -1;
        if (a.CodEmpleado > b.CodEmpleado) return 1;
        return 0;
      });

      grupos.forEach((grupo, grupoIndex) => {
        // Cada empleado en una página nueva (excepto el primero)
        if (grupoIndex > 0) {
          doc.addPage();
        }

        // Función para dibujar encabezado del empleado
        const dibujarEncabezadoEmpleado = (y) => {
          doc.setFontSize(11);
          doc.setTextColor(200, 0, 0); // Rojo
          doc.setFont('helvetica', 'bold');
          doc.text(`${grupo.CodEmpleado} - ${grupo.Nombre}`, 14, y);
          doc.setFontSize(9);
          doc.setTextColor(0, 0, 0);
          doc.setFont('helvetica', 'normal');
          doc.text(`Departamento: ${grupo.Departamento}`, 14, y + 5);
        };

        // Encabezado del grupo (Empleado) - ajustar según si es el primero o no
        // El primer empleado necesita más espacio porque está después del encabezado del reporte
        let startY = grupoIndex === 0 ? 45 : 20;
        dibujarEncabezadoEmpleado(startY);
        startY += 12;

        // Preparar datos de la tabla para este empleado
        const rows = grupo.registros.map(row => {
          return [
            Formatter.dateFormatter(row.Fecha) || '',
            formatTime(row.HoraEntrada),
            formatTime(row.HoraSalida),
            (row.TotalHorasExtras || 0).toFixed(2),
            (row.TotalHorasEnTurno || 0).toFixed(2),
            (row.HorasCitasMedicas || 0).toFixed(2),
            (row.HorasVacaciones || 0).toFixed(2),
            (row.HorasPermisos || 0).toFixed(2),
            (row.HorasIncapacidadTemporal || 0).toFixed(2),
            (row.TotalHorasLaboradas || 0).toFixed(2)
          ];
        });

        // Guardar número de página inicial para este empleado
        const paginaInicial = doc.internal.getNumberOfPages();

        // Calcular ancho total de la tabla
        const anchoTotalTabla = 25 + 22 + 22 + 20 + 25 + 22 + 22 + 22 + 25 + 30; // Suma de todos los anchos de columnas
        // Calcular margen izquierdo para centrar la tabla (en modo landscape el ancho es ~297mm o 842 puntos)
        const pageWidth = doc.internal.pageSize.getWidth();
        const marginLeft = (pageWidth - anchoTotalTabla) / 2;

        // Generar tabla para este empleado con manejo automático de páginas
        autoTable(doc, {
          head: [columns],
          body: rows,
          startY: startY,
          styles: {
            fontSize: 8,
            cellPadding: 2,
            lineColor: [0, 0, 0],
            lineWidth: 0.1
          },
          headStyles: {
            fillColor: [200, 0, 0], // Rojo para encabezado
            textColor: [255, 255, 255], // Blanco
            fontStyle: 'bold',
            lineWidth: 0.1,
            lineColor: [0, 0, 0]
          },
          bodyStyles: {
            textColor: [0, 0, 0],
          },
          alternateRowStyles: {
            fillColor: [245, 245, 245],
          },
          columnStyles: {
            0: { cellWidth: 25 }, // Fecha
            1: { cellWidth: 22 }, // H. Entrada
            2: { cellWidth: 22 }, // H. Salida
            3: { cellWidth: 20 }, // H. Extras
            4: { cellWidth: 25 }, // H. Trabajadas
            5: { cellWidth: 22 }, // Citas Méd.
            6: { cellWidth: 22 }, // Vacaciones
            7: { cellWidth: 22 }, // Permisos
            8: { cellWidth: 25 }, // Incapacidad
            9: { cellWidth: 30 }  // Total H. Laboradas
          },
          margin: { 
            top: startY, 
            right: marginLeft, 
            bottom: 20, 
            left: marginLeft 
          },
          // Callback cuando se dibuja una página
          didDrawPage: function (data) {
            // Si autoTable creó una nueva página (página adicional para este empleado)
            const paginaActual = doc.internal.getNumberOfPages();
            if (paginaActual > paginaInicial) {
              // Dibujar encabezado del empleado en la nueva página
              dibujarEncabezadoEmpleado(15);
            }
          }
        });
      });

      // Nombre del archivo
      const nombreArchivo = filtros.codEmpleado 
        ? `Reporte_Actividad_${filtros.codEmpleado}_${fechaInicioFormateada.replace(/\//g, '-')}_${fechaFinalFormateada.replace(/\//g, '-')}.pdf`
        : `Reporte_Actividad_TODOS_${fechaInicioFormateada.replace(/\//g, '-')}_${fechaFinalFormateada.replace(/\//g, '-')}.pdf`;

      doc.save(nombreArchivo);
      msgNotificacion('Reporte generado exitosamente.', 'success');
    } catch (error) {
      console.error('Error al generar PDF:', error);
      msgNotificacion('Error al generar el PDF.', 'error');
    }
  }

  //
  let initPage = false;

  useEffect(() => {
    document.title = `Registro de Marcaciones - ${NAME_PROJECT}`

    try {
      dispatch(showProgress(true))

      setTimeout(() => {
        if (!initPage) {
          initPage = true

          const data = {
            codEmpleado: userLogin.CodigoEmpleado
          }

          getMarcaciones(data)

          getDatosEmpleadosCbo()
        }

        dispatch(showProgress(false))
      }, 1000)
    } catch (error) {
      console.error(error)
    }
  }, [])

  return <div className='App-content'>
  <Heading className='mt-0 w-100 heading heading-title'>
    <div className='heading-text w-100 heading-text-marcaciones'>
      <i className='bx bx-history me-2'></i>
      <span>Historial de Marcaciones</span>
    </div>

      <Autocomplete
        id="cboEmpleados"
        getOptionLabel={option => (option.id + ' - ' + option.label)}
        isOptionEqualToValue={(option, value) => option.value === value.value}
        options={dataEmpleadosCbo}
        fullWidth
        className='me-2 text-transform-none'
        value={empleadoSelected || null}
        onChange={handleChangeEmpleado}
        renderInput={(params) => <TextField {...params} label="Listado de Empleados" className='text-transform-none' />}
      />
    
    <div className='d-flex dv-filt-fechas-marc'>
      <Tooltip title='Refrescar datos'>
        <Button
          variant='outlined'
          className='text-transform-none me-2 btn-refresh-marc'
          color='info'
          startIcon={<RestartAltIcon />}
          onClick={() => refreshMarcaciones()}
          size='small'
        >
          Refrescar
        </Button>
      </Tooltip>

      <div className='d-flex'>
        <TextField
            id='txtFechaInicio'
            name='fechaIni'
            type='date'
            label='Fecha inicial'
            size='small'
            value={valueFechas.fechaIni}
            onChange={handleChangeFechas}
            className='ms-auto mx-1 filt-fechas-marc'
            InputLabelProps={{
              shrink: true,
              className: 'LabelMui'
            }}
          />

          <TextField
            id='txtFechaFinal'
            name='fechaFin'
            type='date'
            label='Fecha final'
            size='small'
            value={valueFechas.fechaFin}
            onChange={handleChangeFechas}
            className='mx-1 filt-fechas-marc'
            InputLabelProps={{
              shrink: true,
              className: 'LabelMui'
            }}
          />
      </div>

      {/* Botón de Registro Manual - Solo para Admin (rol 1) y RRHH (rol 2) */}
      {userLogin && (Number(userLogin.CodigoRol) === 1 || Number(userLogin.CodigoRol) === 2) && (
        <Tooltip title='Registrar marcación manual'>
          <Button
            variant='contained'
            className='text-transform-none ms-2'
            color='success'
            startIcon={<AddIcon />}
            onClick={handleOpenModalRegistro}
            size='small'
            disabled={loading}
          >
            Registrar Marcación
          </Button>
        </Tooltip>
      )}

      {/* Botón de Reporte PDF - Solo para Admin (rol 1) y RRHH (rol 2) */}
      {userLogin && (Number(userLogin.CodigoRol) === 1 || Number(userLogin.CodigoRol) === 2) && (
        <Tooltip title='Generar reporte PDF de actividad'>
          <Button
            variant='contained'
            className='text-transform-none ms-2'
            color='error'
            startIcon={<PictureAsPdfOutlinedIcon />}
            onClick={generarReportePDF}
            size='small'
            disabled={loading}
          >
            Reporte PDF
          </Button>
        </Tooltip>
      )}
    </div>
  </Heading>

    <>
      {isMobile ? (
        // Vista móvil: Lista de tarjetas
        loading ?
        <Grid container spacing={1} paddingX={1} height='100%' textAlign='center' alignItems='center'>
          <Grid item xs={12}>
            <CircularProgress color='inherit' />
          </Grid>
        </Grid>
        :
        <Grid container spacing={1} paddingX={1} paddingTop={1}>
          {filteredData.map((row) => (
            <Grid item xs={12} key={row.Consecutivo}>
              <Card>
                <CardContent>
                  <Typography variant="h6"><strong>Registro #{row.Consecutivo}</strong></Typography>
                  <Typography variant="body2">
                    <strong>Empleado: </strong><span className='mx-1'>{row.CodigoEmpleado} - {row.Nombre.toUpperCase()}</span>
                  </Typography>
                  <Typography variant="body2">
                    <strong>Fecha marcación:</strong><span className='mx-1 text-danger fw-bolder'>{Formatter.dateTimeFormatter(row.FechaHora)}</span>
                  </Typography>  
                  <Typography
                    variant="body2"
                    className={
                      row?.StatusText === 'ENTRADA' ? classes.customCellIn : 
                      (row?.StatusText && row.StatusText.slice(0,8) === 'ALMUERZO') ? classes.customCellBreak :
                      row?.StatusText === 'SALIDA' ? classes.customCellOut :
                      null
                    }
                    display='flex'
                    alignItems='center'
                    borderRadius={4}
                    paddingLeft={0.5}
                  >
                  <strong>Estatus:</strong><span className='mx-1'>{row.StatusText}</span>
                  </Typography>
                </CardContent>
              </Card>
            </Grid>
          ))}
        </Grid>
      ) : (
        <Grid container spacing={1}>
          <Grid item xs={12} md={12} marginX={1}>
            <Item className='MuiPaper-root-dataGrid-marcaciones'>
              <DataGrid
                rows={filteredData}
                columns={columns.map((column) => ({
                  ...column,
                  //headerClassName: column.field === 'CodigoEmpleado' ? classes.customColumn : '', // Agregar la clase CSS al titulo
                  cellClassName: getCellClassName, // Utilizar la función getCellClassName para aplicar la clase CSS
                }))}
                getRowId={(row) => row?.Consecutivo}
                pageSize={PAGE_SIZE}
                pageSizeOptions={[5, 10, 25, 50, 100]}
                loading={loading}
                localeText={Formatter.localizedTextsMapColumns}
                // Ocultar la casilla de check all.
                sx={{
                  "& .MuiDataGrid-columnHeaderCheckbox .MuiDataGrid-columnHeaderTitleContainer": {
                    display: "none"
                  }
                }}
                showCellVerticalBorder
                showColumnVerticalBorder
                //density='compact'
                slots={{
                  noRowsOverlay: CustomNoRowsOlverlay,
                  toolbar: CustomToolBar,
                }}
              />
            </Item>
          </Grid>
        </Grid>
      )
      }

  {/* Modal de Registro Manual de Marcación */}
  <Dialog
    open={modalRegistroManual.open}
    onClose={handleCloseModalRegistro}
    maxWidth="sm"
    fullWidth
  >
    <DialogTitle>
      <i className='bx bx-time me-2'></i>
      Registrar Marcación Manual
    </DialogTitle>
    <DialogContent>
      <DialogContentText sx={{ mb: 2 }}>
        Complete los datos para registrar una marcación manual. Este registro quedará en la auditoría.
      </DialogContentText>
      
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
        {/* Empleado */}
        <Autocomplete
          id="cboEmpleadoModal"
          getOptionLabel={option => (option.id + ' - ' + option.label)}
          isOptionEqualToValue={(option, value) => option.value === value.value}
          options={dataEmpleadosCbo}
          fullWidth
          value={modalRegistroManual.empleado || null}
          onChange={(event, newValue) => handleChangeModalRegistro('empleado', newValue)}
          renderInput={(params) => <TextField {...params} label="Empleado *" required />}
        />

        {/* Fecha */}
        <TextField
          id="txtFechaModal"
          name="fecha"
          type="date"
          label="Fecha *"
          fullWidth
          value={modalRegistroManual.fecha}
          onChange={(e) => handleChangeModalRegistro('fecha', e.target.value)}
          InputLabelProps={{
            shrink: true,
          }}
          required
        />

        {/* Hora */}
        <TextField
          id="txtHoraModal"
          name="hora"
          type="time"
          label="Hora *"
          fullWidth
          value={modalRegistroManual.hora}
          onChange={(e) => handleChangeModalRegistro('hora', e.target.value)}
          InputLabelProps={{
            shrink: true,
          }}
          inputProps={{
            step: 60, // 1 minuto
          }}
          required
        />

        {/* Tipo de Marcación */}
        <FormControl fullWidth required>
          <InputLabel id="tipo-marcacion-label">Tipo de Marcación *</InputLabel>
          <Select
            labelId="tipo-marcacion-label"
            id="tipo-marcacion"
            value={modalRegistroManual.tipoMarcacion}
            label="Tipo de Marcación *"
            onChange={(e) => handleChangeModalRegistro('tipoMarcacion', e.target.value)}
          >
            <MenuItem value="ENTRADA">ENTRADA</MenuItem>
            <MenuItem value="SALIDA">SALIDA</MenuItem>
            <MenuItem value="ALMUERZO">ALMUERZO</MenuItem>
          </Select>
        </FormControl>
      </Box>
    </DialogContent>
    <DialogActions>
      <Button onClick={handleCloseModalRegistro} color="primary">
        Cancelar
      </Button>
      <Button 
        onClick={handleRegistrarMarcacionManual} 
        color="success"
        variant="contained"
      >
        Registrar
      </Button>
    </DialogActions>
  </Dialog>
    </>
</div>
}